__turbopack_context__.v({
  "buttonWrapper": "ModalContent-module__CvBzYG__buttonWrapper",
  "container": "ModalContent-module__CvBzYG__container",
  "importantInfo": "ModalContent-module__CvBzYG__importantInfo",
  "link": "ModalContent-module__CvBzYG__link",
  "logoContainer": "ModalContent-module__CvBzYG__logoContainer",
  "miniParagraph": "ModalContent-module__CvBzYG__miniParagraph",
  "multipleButtonsWrapper": "ModalContent-module__CvBzYG__multipleButtonsWrapper",
  "paragraph": "ModalContent-module__CvBzYG__paragraph",
  "singleButtonWrapper": "ModalContent-module__CvBzYG__singleButtonWrapper",
});
